import { mergeMap, retry, shareReplay } from 'rxjs/operators';
// Utils / Constants
import { STATIC_MENU_URL_MAP } from './constants';
// Types / Interfaces
import { StaticFileUrlService } from '../static-file-url.service';
// Services
import { AjaxService } from '../core/ajax.service';
import * as i0 from "@angular/core";
import * as i1 from "../core/ajax.service";
import * as i2 from "../static-file-url.service";
/**
 * Static Menu Service
 *
 * A service that fetches menu data stored in .json files (because they are not expected to change).
 */
export class StaticMenuService {
    constructor(ajaxService, staticFileUrlService) {
        this.ajaxService = ajaxService;
        this.staticFileUrlService = staticFileUrlService;
        this.cachedMenuMap = {};
    }
    /**
     * Given the menu type and group of menu items, get the absolute URL to that file and retrieve the json data.
     * The json data describes the categories in each menu, and any sublist items under those categories.
     *
     * @param menuType: The type of menu data that is fetched for i.e. metric menu.
     * @param submenuType: A specific group of items under menuType i.e. popular metrics.
     */
    getStaticMenu(menuType, submenuType) {
        const staticJsonUrl = STATIC_MENU_URL_MAP[menuType][submenuType];
        const cachedMenu$ = this.cachedMenuMap[staticJsonUrl];
        if (cachedMenu$) {
            return cachedMenu$;
        }
        const menu$ = this.staticFileUrlService.getAbsoluteURL(staticJsonUrl).pipe(mergeMap((cachedUrl) => {
            return this.ajaxService.getDataObserveBody(cachedUrl, undefined, {
                'Cache-Control': 'max-age=31536000', // Cache for 1 year
            });
        }), retry(3), shareReplay(1));
        this.cachedMenuMap[staticJsonUrl] = menu$;
        return menu$;
    }
}
StaticMenuService.ɵfac = function StaticMenuService_Factory(t) { return new (t || StaticMenuService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.StaticFileUrlService)); };
StaticMenuService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: StaticMenuService, factory: StaticMenuService.ɵfac, providedIn: 'root' });
